import { useEffect, useId } from "react";

import type { TooltipProps } from "./tooltip";

export function useA11y(
  props: TooltipProps,
  containerRef: React.RefObject<HTMLElement | SVGElement | null>,
  togglerRef?: React.RefObject<HTMLElement | SVGElement | null>,
): string {
  const id = `tooltip-${useId()}`;

  useEffect(() => {
    const toggler = containerRef?.current ?? togglerRef?.current;

    if (!toggler || props.disabled) {
      return;
    }

    if (props.ariaType === "label") {
      toggler.setAttribute("aria-labelledby", id);
    } else if (props.ariaType === "description") {
      toggler.setAttribute("aria-describedby", id);
    }

    return () => {
      if (props.ariaType === "label") {
        toggler.removeAttribute("aria-labelledby");
      } else if (props.ariaType === "description") {
        toggler.removeAttribute("aria-describedby");
      }
    };
  }, [togglerRef, containerRef, id, props.ariaType, props.disabled]);

  return id;
}
